import { render, staticRenderFns } from "./law-cases-list.vue?vue&type=template&id=2dcdca98"
import script from "./law-cases-list.vue?vue&type=script&lang=js"
export * from "./law-cases-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports